import { useState } from "react";
import { dateFormat } from "../../const/date";
import Swal from "sweetalert2";

import { Link } from "react-router-dom";
import axios from "axios";

type BlogData = {
  data: {
    category: Array<string>;
    title: Array<string>;
    link: Array<string>;
    description: Array<string>;
    pubDate: Array<string>;
  }[];
};

const Blog = ({ data }: { data: BlogData[] | any[] }) => {
  const blog = ParseData({ data });

  const [name, setName] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [address, setAddress] = useState<string>("");
  const [service, setService] = useState<string>("");
  const [contents, setContents] = useState<string>("");

  const [loading, setLoading] = useState(false);

  const handlerPostContact = async () => {
    if (!name || !phone || !address) {
      Swal.fire({
        title: "이름, 연락처, 주소를 모두 입력해주세요.",
        icon: "error",
      });
      return false;
    }

    if (phone.length !== 11 || !phone.includes("010")) {
      alert("010을 포함한 연락처를 모두 입력해주세요.");
      return false;
    }

    if (!window.confirm("문의 접수를 위한 개인정보 수집에 동의하시나요?")) {
      return false;
    }

    setLoading(true);

    await axios
      .post("/api/contact", {
        name: name,
        phone: phone,
        address: address,
        service: service,
        type: "간편상담",
        contents: contents,
        path: sessionStorage.getItem("path"),
      })
      .then((res) => {
        if (res.data.result === "0000") {
          Swal.fire({
            title: "문의 완료!",
            text: "문의 등록이 완료되었습니다.",
            icon: "success",
          }).then(() => (window.location.href = "/transform"));
        }
      })
      .catch((e) => {
        setLoading(false);
        Swal.fire({
          title: e,
          icon: "error",
        }).then(() => (window.location.href = "/"));
      });
  };
  return (
    <div
      id="blog"
      className="relative w-full h-full px-[calc((100%-var(--container))/2)]  mx-auto py-14 lg:py-28 xl:pb-36"
    >
      <div className="relative w-full h-full max-w-[1600px] mx-auto grid lg:grid-cols-3 gap-5 ">
        <div
          data-aos="fade-up"
          className="hidden xl:block relative w-full max-w-96 h-full bg-[url('../public/images/phone.png')] bg-no-repeat bg-contain pt-20 2xl:pt-24 pb-14 lg:pb-28 pl-4 pr-6 3xl:px-5 mx-auto"
        >
          <div className="relative w-32 h-auto mx-auto">
            <img
              className="!relative w-full h-auto object-contain"
              alt="logo"
              src={"/images/logo.png"}
              width={514}
              height={132}
            />
          </div>
          <div className="relative w-full h-fit bg-primary text-white mt-3 flex justify-center items-center gap-5">
            <div className="relative w-[1px] h-8 bg-white"></div>
            <h5 className="bold pt-1">간편상담 바로가기</h5>
            <div className="relative w-[1px] h-8 bg-white"></div>
          </div>
          <div className=" relative w-full h-full py-3 px-1">
            <div className=" relative w-full h-fit grid grid-cols-2 gap-3">
              <div className=" relative w-full h-fit">
                <label htmlFor="name1">
                  이름&nbsp;<span className="text-[var(--red-color)]">*</span>
                </label>
                <input
                  type="text"
                  placeholder="이름을 입력해주세요"
                  value={name}
                  id="name1"
                  onChange={(e) => setName(e.target.value)}
                />
              </div>
              <div className=" relative w-full h-fit">
                <label htmlFor="phone1">
                  연락처&nbsp;<span className="text-[var(--red-color)]">*</span>
                </label>
                <input
                  type="text"
                  placeholder="연락처를 입력해주세요"
                  value={phone}
                  id="phone1"
                  onChange={(e) =>
                    setPhone(
                      e.target.value
                        .replace(/[^0-9.]/g, "")
                        .replace(/(\..*)\./g, "$1")
                    )
                  }
                />
              </div>
              <div className="relative w-full h-fit">
                <label htmlFor="address1">
                  주소&nbsp;<span className="text-[var(--red-color)]">*</span>
                </label>
                <input
                  type="text"
                  placeholder="주소를 입력해주세요"
                  id="address1"
                  value={address}
                  onChange={(e) => setAddress(e.target.value)}
                />
              </div>
              <div className=" relative w-full h-fit">
                <label htmlFor="service2">문의종류</label>
                <select
                  name="service2"
                  id="service2"
                  onChange={(e) => setService(e.target.value)}
                >
                  <option value="">서비스 목록</option>
                  <option value="유품정리">유품정리</option>
                  <option value="쓰레기집청소">쓰레기집청소</option>
                  <option value="특수청소">특수청소</option>
                  <option value="빈집정리">빈집정리</option>
                  <option value="고독사청소">고독사청소</option>
                  <option value="폐기물처리">폐기물처리</option>
                </select>
              </div>
              <div className="col-span-2 row-span-2 relative w-full h-fit">
                <label htmlFor="contents1">문의 내용</label>
                <textarea
                  placeholder="내용을 입력해주세요"
                  value={contents}
                  name="contents1"
                  id="contents1"
                  onChange={(e) => setContents(e.target.value)}
                ></textarea>
                <div className="relative w-full h-fit flex justify-between items-center">
                  <p className="text-xs leading-tight">
                    문자&nbsp;접수&nbsp;후&nbsp;
                    <span className="text-[var(--red-color)]">
                      20분&nbsp;이내에
                    </span>
                    <br />
                    직접&nbsp;전화드릴&nbsp;예정입니다.
                  </p>
                  <button
                    type="button"
                    onClick={handlerPostContact}
                    disabled={loading}
                    // onClick={() => window.alert("준비중입니다.")}
                    className=" relative w-fit h-fit pt-1 px-5 bg-primary text-white rounded-sm"
                  >
                    <h5 className="font-light text-shadow">전송하기</h5>
                  </button>
                </div>
              </div>
              <div className="col-span-2 relative w-full h-fit bg-primary py-3 2xl:mt-2 rounded-md cursor-pointer">
                <img
                  onClick={() => {
                    window.location.href = "tel:010-9806-4573";
                  }}
                  className="!relative w-full h-full max-w-screen-md px-5 mx-auto object-contain"
                  src="/images/phoneNum.png"
                  alt="number"
                  width={1461}
                  height={144}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="col-span-2 relative w-full h-fit min-h-96">
          <div id="title" className="relative w-full h-fit mt-10 mb-5">
            <div className="relative w-full h-fit">
              <h2 className="leading-none gmedium">
                <span className="text-primary">몽땅</span>
                &nbsp;BLOG&nbsp;작업사례
              </h2>
            </div>
            <p className="text-lg lg:text-xl mt-3 ">
              정직하고 완벽한 서비스만을 추구하는 몽땅! <br />
              몽땅 유품정리의 생생한 현장을 직접 확인해보세요!
            </p>
          </div>
          <div className="relative w-full max-w-screen-lg h-fit grid grid-cols-2 grid-rows-5 lg:grid-cols-3 lg:grid-rows-3 gap-3 xl:gap-5">
            {blog.map((v: any, i: number) => (
              <Link
                key={i}
                to={v.link[0]}
                target="_blank"
                className={
                  i === 8
                    ? "relative w-full h-full hidden md:block"
                    : "relative w-full h-full"
                }
              >
                <div className="relative w-full h-full grid 2xl:gap-3 bg-gray-100 p-3 rounded-3xl text-left border hover:border-main cursor-pointer transition-all duration-300">
                  <p
                    className={`relative w-full whitespace-nowrap overflow-hidden overflow-ellipsis lg:text-lg h-fit`}
                  >
                    {v.title[0]}
                  </p>
                  <small
                    className={`relative w-full whitespace-normal overflow-hidden overflow-ellipsis h-9 lg:h-10 break-words line-clamp-2 lg:text-sm opacity-60`}
                  >
                    {v.description[0]}
                  </small>
                  <div className="pt-2 lg:flex justify-between items-end">
                    <small className="hidden xl:block opacity-40 text-xs whitespace-nowrap">
                      {dateFormat(v.pubDate[0])}
                    </small>
                    <small className="text-secondary text-xs whitespace-nowrap">
                      {v.category[0]}
                    </small>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

const parseString = require("xml2js").parseString;

const ParseData = ({ data }: { data: any[] }) => {
  const dataArr: {
    title: any;
    link: any;
    description: any;
    pubDate: any;
    category: any;
  }[] = [];

  data.length > 0 &&
    parseString(data, (e: any, data: any) => {
      // eslint-disable-next-line
      data.rss.channel[0].item.map((v: any, i: any) => {
        i < 8 &&
          dataArr.push({
            title: v.title,
            link: v.link,
            description: v.description,
            pubDate: v.pubDate,
            category: v.category,
          });
      });
    });

  return dataArr;
};

export default Blog;
